import { Wallet} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const earnWalletProfit = {
    id: 'earnWalletProfit',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'earnWalletProfit',
            title: 'Earn Wallet Profit',
            type: 'item',
            url: '/earnWalletProfit',
            icon: Wallet,
            breadcrumbs: false
        },
       
    ]
};

export default earnWalletProfit;
